import { memo, useCallback, useMemo, useRef } from 'react';
import { useDispatch } from 'react-redux';
import PropTypes from 'prop-types';

import { QueryDropdown } from 'basic-components';
import Query from 'dashboard-services/api/Query';

import getApiConfig from 'api/ApiConfig';
import { dataSharingQueries } from 'queries/modules/datasharing';

const emptyArray = [],
      LOCAL_PROVIDER_ARRAY = [{ label: dataSharingQueries.LOCAL_PROVIDER.readableName, value: dataSharingQueries.LOCAL_PROVIDER.name }]
const DataSharingProvider = ({
  value,
  onChange,
  size = undefined,
  menuPortalTarget = undefined,
  ref,
  ...props
}) => {
  const dispatch = useDispatch(),
        getApiConfigLocal = useCallback(() => dispatch(getApiConfig()), [dispatch]),
        getQueryBuilder = useCallback(() => 
          new Query.Builder(getApiConfigLocal())
            .withFetching(false)
            .withShouldDisplayError(false)
        , [getApiConfigLocal]),
        { fetchNextPage: fetchMoreProviders, isFetching: isFetchingProviders, isFetchingNextPage: isFetchingNextPageProviders, data: providersRaw = emptyArray } = dataSharingQueries.useGetProducers({
          getQueryBuilder,
          alwaysReturnProducer: true,
          includeSelfProducer: true
        }),
        providers = useMemo(() => providersRaw ? (providersRaw || emptyArray).map(p => ({ value: p.name, label: p.readableName || p.name || p.producerId, producerId: p.producerId })) : LOCAL_PROVIDER_ARRAY, [providersRaw]),
        defaultValue = useMemo(() => {
          const localValue = value || providers.find(provider => provider.producerId === 0)?.value || dataSharingQueries.LOCAL_PROVIDER
          return providers.find(p => p.value === localValue) || LOCAL_PROVIDER_ARRAY[0]
        }, [providers, value]),
        sharingRef = useRef()
  return (
    <QueryDropdown
        {...props}
        defaultValue={defaultValue}
        fetchNextPage={fetchMoreProviders}
        isFetching={isFetchingProviders || isFetchingNextPageProviders}
        menuPortalTarget={menuPortalTarget || document.body}
        onChange={onChange}
        options={providers}
        ref={ref || sharingRef}
        required={false}
        size={size}
    />
  )
}

DataSharingProvider.displayName = "DataSharingProvider"


DataSharingProvider.propTypes = {
  menuPortalTarget: PropTypes.any,
  onChange: PropTypes.func.isRequired, 
  size: PropTypes.string,
  value: PropTypes.any.isRequired,
}

export default memo(DataSharingProvider);